import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';

export const getTripTypeList = ({ archived, from }) => {
  let query = `/transport/trips/types?includeArchived=${archived}&limit=50`;
  if (from) query += `&from=${from}`;
  return axiosGetWithCookies(query);
};

export const createTripType = tripType =>
  axiosPostWithCookies(`/transport/trips/types`, { data: tripType });

export const updateTripType = (id, tripType) =>
  axiosPutWithCookies(`/transport/trips/types/${id}`, { data: tripType });
